import * as React from 'react';
import { Node } from '@msdyn365-commerce-modules/utilities';
import { RichText, RichTextComponent } from '@msdyn365-commerce/core';

export interface ISleepExpertSummaryComponentProps {
        sleepExpertOpinionHeadingText : RichText,
        sleepExpertSummaryText?:string;
    }
export  const SleepExpertSummaryComponent: React.FC<ISleepExpertSummaryComponentProps> = ({sleepExpertOpinionHeadingText,sleepExpertSummaryText}) => {
    return (
     <Node className='ms-buybox__sleep-expert-summary'>
          <Node className='ms-buybox__sleep-expert-summary-heading' tag='h2' >
            <RichTextComponent  text={sleepExpertOpinionHeadingText} />
            </Node>
          <Node
           className='ms-buybox__sleep-expert-summary-text' tag='p'>
              {sleepExpertSummaryText}
        </Node>
     </Node>
    );
};

export default SleepExpertSummaryComponent;